export const RogersReportHistoryDetailsModalComponent = {
    template:  /*html*/`<div class="modal-header">
            <h1>Rogers Report Job Details</h1>
        </div>
        <div class="modal-body">
            <h3 class="h3">Options</h3>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Start Date</label>
                        <div class="form-control-plaintext ng-binding">
                           {{$ctrl.resolve.report.StartDate | date : 'MMM d, yyyy'}}
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>End Date</label>
                        <div class="form-control-plaintext ng-binding">
                            {{$ctrl.resolve.report.EndDate | date : 'MMM d, yyyy'}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button"
                    class="btn btn-plain"
                    ng-click="$ctrl.close({ $value: 'cancel' })">
                Close
            </button>
        </div>`
    ,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};


export const RogersReportJobDetailsModal = {
    component: "apexRogersReportHistoryDetailModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static',
}
